import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';

import FooterLinks from './FooterLinks/FooterLinks';
import LightFooter, { fitsLightFooter } from './LightFooter/LightFooter';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();

  // If footer asset is not set, render only the landing-page links.
  if (Object.keys(footer).length === 0) {
    return <FooterLinks />;
  }

  // SectionBuilder brings PageBuilder and its markdown stack onto every page, so the usual
  // footer (link lists, plain text) skips it. Anything else from the Console still uses it.
  if (fitsLightFooter(footer)) {
    return (
      <>
        <FooterLinks />
        <LightFooter {...footer} linkLogoToExternalSite={topbar?.logoLink} />
      </>
    );
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return (
    <>
      <FooterLinks />
      <SectionBuilder sections={[footerSection]} />
    </>
  );
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
